import MatchSwitchLoader from 'modules/overlay-v2/ui/components/match-switch-loader';
import ReadinessChecklist from 'modules/overlay-v2/ui/components/readiness-checklist/readiness-checklist';
import useMatchSwitchLoaderPreview from 'modules/overlay-v2/ui/hooks/use-match-switch-loader-preview';
import { OverlayReadiness } from 'modules/overlay-v2/ui/hooks/use-overlay-readiness';
import React from 'react';

interface PreparationScreenProps {
  readiness: OverlayReadiness;
}

/**
 * Экран поверх табло, пока матч готовится: чеклист или знак ImGame — по
 * `readiness.preparationScreen`. Общий для оверлея и панели управления.
 *
 * С `?loaderPreview=1|loop` в ссылке вместо него всегда знак: в жизни он виден секунду-две,
 * а проверить нужно блик, уход и прозрачный фон в OBS (`useMatchSwitchLoaderPreview`).
 */
function PreparationScreen({ readiness }: PreparationScreenProps) {
  const preview = useMatchSwitchLoaderPreview();

  if (preview) {
    return preview.isVisible ? <MatchSwitchLoader key={preview.cycle} isClosing={preview.isClosing} /> : null;
  }

  switch (readiness.preparationScreen) {
    case 'checklist':
      return <ReadinessChecklist readiness={readiness} onRetry={readiness.onRetry} />;
    case 'switchLoader':
      return <MatchSwitchLoader isClosing={readiness.isReady} />;
    default:
      return null;
  }
}

export default PreparationScreen;
